// extracted by mini-css-extract-plugin
export default {"btnOtp":"doctorStyle_btnOtp__NJFAR"};